<template>
	<div
		@mouseenter="mouseEnter"
		@mouseleave="mouseOut">
		<div
			:class="[
				'editable-field',
				'editable-html-editor',
				'inner-hover',
				{'can-edit':editable},
				{'active':focused}]">
			<div>
				<div :class="['editable-label', {'title':labelLarge}, {'label-bold':labelBold}]">{{label}}</div>
				<div
					:class="['editable-value', 'ql-editor',{'visible':focused}]"
					:style="{visible:focused}"
					v-html="model">
				</div>
				<div
					v-if="editable"
					:class="['editable-input',{'visible':!focused}]"
					id="htmlEditor" 
					ref="htmlEditor"
                    @paste="pasteValues"
					>
					<html-editor
						:error="error || (propToUpdate === `description` && count > 5000)"
						v-model="model"
						:filter="filter"
						:max-length="maxLength"
					/>
					<div class="editable-action">
						<v-btn
							small
							color="primary"
							@click="saveEdit">
							SAVE
						</v-btn>
						<v-btn
							small
							@click="cancelEdit">
							CANCEL
						</v-btn>
						<div class="editable-counter">{{count}}</div>
					</div>
				</div>
				<div class="editable-edit" v-if="!editing" :style="{opacity: active && !focused ? '1' : '0'}">
					<v-btn 
						small
						color="primary"
						@click="startEdit">
						Edit
					</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
	import HTMLEditor from '@/components/ui/_global/utils/HTMLEditor/HTMLEditor_Quill.vue'
	import stripHtml from "../../../../helpers/stripHtml"
    import {
        VUEX_SNACKBAR_SHOW
    } from '@/store/constants/snackbar'
	export default {
		name: 'editable-html-editor',
		components: {
			'html-editor' : HTMLEditor
		},
		props: {
			value: {
				type: String,
				required: false,
				default: null
			},
			editable: {
				type: Boolean,
				required: false,
				default: false
			},
			label: {
				type: String,
				required: false,
				default: null
			},
			labelBold: {
				type: Boolean,
				required: false,
				default: false
			},
			labelLarge: {
				type: Boolean,
				required: false,
				default: false
			},
			error: {
				type: Boolean,
				required: false,
				default: false
			},
			propToUpdate: {
				type: String,
				required: false,
				default: null
			},
			dispatchOnSave: {
				type: Function,
				required: false,
				default: null
			},
			filter: {
				type: String,
				default: 'all'
			},
			maxLength: {
				type: Number,
				default: 5000
			},
		},
		data:() => ({
			model: '',
			focused: false,
			active: false,
			editing: false,
			count: null
		}),
		created() {
			this.initialize()
		},
		watch: {
			value: {
				handler(val) {
					this.initialValue = val
				}
			},
			model: {
				deep: true,
				handler(val) {
				    let model = stripHtml(val)
                    if (model && this.maxLength && model.length > this.maxLength) {
                        //SNACK
                        this.$store.dispatch(VUEX_SNACKBAR_SHOW, {
                            description_text: "Paste exceeds maximum field size.",
                            button_text: "",
                            timeout: 2000,
                            button_dispatch: "",
                            button_dispatch_payload: {},
                        })
                        if (this.prevModel) {
                            this.$refs.htmlEditor.children[0].children[1].children[0].innerHTML = this.prevModel
                            this.model = this.prevModel
                            return
						}
					}
					this.count = model.length || ''
                }
			},
		},
		methods: {
			initialize() {
				this.value = (this.value) ? this.value : null
				let b_value = this.value
				this.initialValue = b_value
				this.model = b_value
				this.prevModel = b_value
			},

			startEdit() {
                if(this.editable) {
					this.editing = true;
					this.focused = true
				}
			},

			endEdit() {
			    this.editing = false
				this.focused = false

				if (this.model !== this.initialValue) {
					if (this.dispatchOnSave && this.propToUpdate) {
						this.dispatchOnSave({[this.propToUpdate]: this.model})
					} else {
						this.dispatchOnSave(this.model)
					}
					// Send up the chain in case anything else is watching
					/*this.$emit('save-edit', {
						oldValue: this.initialValue,
						newValue: this.model,
					})*/
				}
			},

			pasteValues() {
			    this.$nextTick(() => {
                    let val = this.$refs.htmlEditor.children[0].children[1].children[0].innerHTML
                    this.model = val
				})
			},

			saveEdit() {
				this.endEdit()
			},

			cancelEdit() {
				this.focused = false
				this.editing = false
				this.model = this.initialValue
			},

			mouseEnter() {
				this.active = true;
			},
			mouseOut() {
				this.active = false;
			}
		}
	}
</script>